export {
  AccessKeySinkSurface,
  AttachmentBar,
  AudioContent,
  Avatar,
  BasicConnectivityStatus,
  BasicSendBox,
  BasicSendBoxToolbar,
  BasicToaster,
  BasicTranscript,
  BasicWebChat,
  Bubble,
  Composer,
  DictationInterims,
  ErrorBox,
  FileContent,
  HTMLVideoContent,
  ImageContent,
  LocalizedString,
  MicrophoneButton,
  ReactWebChat,
  SendButton,
  SendStatus,
  SendTextBox,
  SpeakActivity,
  SuggestedActions,
  TextArea,
  TextContent,
  ThemeProvider,
  Timestamp,
  UploadButton,
  VideoContent,
  VimeoContent,
  YouTubeContent,
  type BasicWebChatProps,
  type ComposerProps,
  type ReactWebChatProps
} from 'botframework-webchat-component/component.js';
